import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, ShoppingCart } from "lucide-react";
import { useCart } from "../context/CartContext";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const { count } = useCart();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [
    { label: "Beranda", id: "hero" },
    { label: "Produk", id: "produk" },
    { label: "Kenapa Kami", id: "kenapa" },
    { label: "Cerita Kami", id: "cerita" },
    { label: "Testimoni", id: "testimoni" },
  ];

  return (
    <nav
      className={`absolute md:fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-5 md:py-3" : "py-5"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4">
        <div
          className={`flex items-center justify-center md:justify-between rounded-full px-5 py-3 transition-all duration-300 ${
            scrolled
              ? "bg-white/90 backdrop-blur-xl shadow-lg shadow-green-900/10"
              : "bg-white/60 backdrop-blur-md"
          }`}
        >
          <Link to="/" className="flex items-center group">
            <img
              src="/logo-green.png"
              alt="ruangrasa"
              className="h-8 w-auto group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => goTo(l.id)}
                className="px-4 py-2 rounded-full text-sm font-semibold text-[#4A6B63] hover:bg-[#E3F1ED] hover:text-[#004743] transition-colors duration-200"
              >
                {l.label}
              </button>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/keranjang"
              className="relative w-11 h-11 rounded-full bg-[#E3F1ED] flex items-center justify-center text-[#004743] hover:bg-[#CFE7E0] transition-colors"
              aria-label="Keranjang"
            >
              <ShoppingCart className="w-5 h-5" />
              {count > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 bg-[#FD7A18] text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {count}
                </span>
              )}
            </Link>
            <button
              onClick={() => goTo("produk")}
              className="flex items-center gap-2 bg-[#004743] text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-[#0A5C53] hover:shadow-lg hover:shadow-green-700/30 hover:-translate-y-0.5 transition-all duration-300"
            >
              <Sparkles className="w-4 h-4" />
              Belanja
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
